/* eslint-disable react/require-default-props */
import React from 'react';
import {View} from 'react-native';
import {isNull} from 'lodash';

import {Loading} from '/component/base/PersonListItem';
import Gutter from '/component/layout/Gutter';
import ReportEmptyState from '/component/partial/report/ReportEmptyState';

import {styles} from './ReportDefaultLoading.style';
import {getLoadingItems} from './ReportDefaultLoading.util';

type Props = {
  total: number | null;
  style?: any;
  isCSBReport?: boolean;
};

function ReportDefaultLoading({
  style = {},
  total = null,
  isCSBReport = false,
}: Props) {
  // Should show loading items if total is null because that means that
  // we don't know the total being loaded and need to load them to check.
  // Null doesn't mean empty, 0 does

  const showLoadingItems =
    isNull(total) || (isCSBReport ? total >= 0 : total > 0);

  return (
    <View style={styles.base}>
      <View style={styles.content}>
        {showLoadingItems ? (
          <View style={styles.content}>
            {getLoadingItems({
              loadingItemComponent: (
                // @ts-expect-error TS(2339): Property 'row' does not exist on type '{ base: { f... Remove this comment to see the full error message
                <Gutter style={[styles.row, style.row]}>
                  <Loading
                    style={{
                      sponsoredDate: style.sponsoredDate,
                    }}
                  />
                </Gutter>
              ),
              total,
              isCSBReport,
            }).map((element, index) =>
              React.cloneElement(element, {key: `loading-item-${index}`}),
            )}
          </View>
        ) : (
          <ReportEmptyState />
        )}
      </View>
    </View>
  );
}

export default ReportDefaultLoading;
